import React from 'react';
import { Link } from 'react-router-dom';
import './nav-bar.scss';
//
const NavBar = ({ isAuthenticated, user, onLogout }) => {
  return (
    <nav className='navbar'>
      <h1>Pap Smear</h1>
      <div className='nav-links'>
        {isAuthenticated ? (
          <>
            <span>Welcome, {user}!</span>
            <button onClick={onLogout}>Logout</button>
          </>
        ) : (
          <Link to='/'>Login</Link>
        )}
      </div>
    </nav>
  );
};

export default NavBar;
